import styled from 'styled-components';
import { palette } from 'styled-tools';

import { fontWeight, FontWeights, maxWidth } from '@calm-web/design-system';

import GridWrapper from '@/components/ui/GridWrapper';
import AccessibilityEssentialsIcon from 'icons/accessibility-essentials.svg';

export const Wrapper = styled.main`
	max-width: 1168px;
	padding: 32px 64px;
	background-color: #f8f8f8;
	margin: 64px auto;
	${fontWeight(FontWeights.Light)};
	border-radius: 16px;
	box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);

	/**
   * Requested by legal to allow 400% zoom without x-scroll.
   * Jira: WOW-1468.
   **/
	${maxWidth('mobileLarge')} {
		overflow-wrap: break-word;
		hyphens: auto;
		padding: 3% 6%;
		margin: auto;
	}

	h1 {
		font-size: 36px;
		${fontWeight(FontWeights.Medium)};
		margin-bottom: 16px;
		text-align: center;
	}

	h2 {
		font-size: 24px;
		${fontWeight(FontWeights.Medium)};
		margin-bottom: 16px;
	}

	h3 {
		font-size: 18px;
		${fontWeight(FontWeights.Medium)};
		margin-bottom: 16px;
	}

	h4 {
		font-size: 16px;
		${fontWeight(FontWeights.Medium)};
		margin-bottom: 16px;
	}

	p {
		margin-bottom: 16px;

		strong {
			${fontWeight(FontWeights.Medium)};
		}
	}

	.alpha ul {
		list-style-type: upper-alpha;
	}

	li {
		margin-bottom: 8px;
	}

	button {
		all: unset;
		cursor: pointer;

		// Adding back in the focus states that were removed with { all: unset } without breaking the requirements of WOW-1468
		// Defaults to browser for color

		&:focus {
			outline-style: auto;
		}
	}

	a,
	button {
		color: ${palette('blue3')};
		text-decoration: underline;
	}
`;

export const UpdatedDate = styled.div`
	font-size: 13.5px;
	margin-bottom: 24px;
	text-align: center;
`;

export const Columns = styled(GridWrapper)`
	margin: 0;
	width: 100%;
`;

export const AccessibilityEssentials = styled(AccessibilityEssentialsIcon)`
	height: 24px;
	margin-left: 14px;
	vertical-align: baseline;
`;
